import React, { useRef, useState, useEffect } from "react";
import dayjs from "dayjs";
import { Empty } from "antd";
import EventLoader from "../../../components/Loader/EventLoader";

interface Holiday {
  holidayDetailId: number;
  name: string;
  holidayOn: string;
  description: string | null;
  isActive: boolean;
}

interface HolidayAnnouncementProps {
  holidays: Holiday[];
  message: string;
}

const HolidayAnnouncement: React.FC<HolidayAnnouncementProps> = ({ holidays, message }) => {
  const scrollContainerRef = useRef<HTMLDivElement>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setLoading(false);
    }, 2000);
    return () => clearTimeout(timer);
  }, []);

  const currentMonthHolidays = holidays;

  const groupedHolidays = currentMonthHolidays
    .slice()
    .sort((a, b) => dayjs(a.holidayOn).valueOf() - dayjs(b.holidayOn).valueOf())
    .reduce((acc: Record<string, Holiday[]>, holiday) => {
      const dateKey = dayjs(holiday.holidayOn).format("YYYY-MM-DD");
      if (!acc[dateKey]) acc[dateKey] = [];
      acc[dateKey].push(holiday);
      return acc;
    }, {});

  return (
    <div className="birth-anniversary relative user--announcement  flex flex-col">
      {loading ? (
        <div className="w-full h-full flex justify-center items-center">
          <EventLoader />
        </div>
      ) : currentMonthHolidays.length > 0 ? (
        <div ref={scrollContainerRef} className="overflow-y-auto mt-2 md:mt-12 flex-1 Leave-notification-container">
          <ul className="birth-anniversary__timeline announcement-notification-content">
            {Object.entries(groupedHolidays).map(([dateKey, holidayGroup]) => {
              const dayNum = dayjs(dateKey).format("D");
              const month = dayjs(dateKey).format("MMM");

              return (
                <li key={dateKey} className="birth-anniversary__lists relative">
                  <div className="date-header">
                    <span className="birth-anniversary__date absolute flex justify-center items-center">{dayNum}</span>
                    <span className="birth-anniversary__month absolute">{month}</span>
                  </div>

                  {holidayGroup.map((holiday) => (
                    <div key={holiday.holidayDetailId} className="birth-anniversary__list-cont items-center flex justify-between py-2 pl-8">
                      <div className="flex items-center">
                        <span className="material-symbols-outlined text-[#d23b7d] mr-2">event</span>
                        <p className="dashboard-announce-body">{holiday.name}</p>
                      </div>
                    </div>
                  ))}
                </li>
              );
            })}
          </ul>
        </div>
      ) : (
        <Empty className="flex flex-col items-center justify-center h-full " imageStyle={{ height: 120 }} description={<span className="text-sm">{message}</span>} />
      )}
    </div>
  );
};

export default HolidayAnnouncement;
